import {useEffect} from 'react';
import * as Yup from 'yup';
import {Formik, Form} from 'formik';

import {PHONE_REGEX} from '../../../utilities/helper/validation';
import FormikInput from '../../../components/formikFileds/input';
import CustomButton from '../../../components/customButton';
import UploadDocument from '../../../module/shop/form/documentUploader';
import Header from '../../../components/header';

import {useLab} from '../../../context/labContext';

import {useNavigate} from 'react-router-dom';
import useScrollToTop from '../../../utilities/hooks/scrollToTop/useScrollToTop';

interface IAddOwner {
  fullName: string;
  age: number | undefined;
  speciality: string | undefined;
  mobileNumber: string;
  phoneNumber: string | undefined;
  nationalIdentity: File | undefined;
}

const AddSchema = Yup.object().shape({
  fullName: Yup.string().required('نام و نام خانوادگی  اجباری می باشد'),
  speciality: Yup.string().required('تخصص اجباری می باشد'),
  age: Yup.number()
    .typeError('مقدار عددی وارد نمایید')
    .required('سن اجباری می باشد'),
  mobileNumber: Yup.string()
    .required('شماره تلفن  همراه اجباری می باشد')
    .matches(PHONE_REGEX, 'شماره تلفن همراه را به درستی وارد نمایید'),
  phoneNumber: Yup.string()
    .matches(/^[0-9]+$/, 'شماره تلفن را به درستی وارد نمایید')
    .required('تلفن اجباری می باشد'),
  nationalIdentity: Yup.mixed().required('تصویر کارت ملی اجباری می باشد'),
});

const ShopOwnerForm = () => {
  useScrollToTop();
  const {lab, updateOwnerInfo} = useLab();
  const initialValues: IAddOwner = {
    fullName: lab?.owner_name || '',
    speciality: lab?.speciality || '',
    mobileNumber: lab?.phone_number || '',
    phoneNumber: lab?.land_line || undefined,
    nationalIdentity: lab?.national_card || undefined,
    age: Number(lab?.owner_age) || undefined,
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (!lab) {
      navigate('/lab/create/type');
    }
  }, [lab, navigate]);
  return (
    <>
      <Header title={'ایجاد آزمایشگاه'} />
      <div className="px-3 pb-4">
        <div className="mt-4">
          <span className="fw-500">
            مشخصات مالک آزمایشگاه <span className="color-red-3">*</span>
          </span>
        </div>
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={AddSchema}
          onSubmit={values => {
            updateOwnerInfo({
              national_card: values.nationalIdentity,
              speciality: values.speciality,
              owner_name: values.fullName,
              phone_number: values.mobileNumber,
              land_line: values.phoneNumber,
              owner_age: values.age,
            });
            navigate('/lab/edit/license');
          }}
        >
          {({setFieldValue, values, touched, errors}) => (
            <Form noValidate>
              <div className="mt-3">
                <div className="mt-4">
                  <FormikInput
                    name="fullName"
                    placeholder="نام و نام خانوادگی"
                    label=""
                    required
                  />
                </div>
                <div className="mt-4">
                  <FormikInput name="age" placeholder="سن" label="" required />
                </div>
                <div className="mt-4">
                  <FormikInput
                    name="speciality"
                    placeholder="تخصص"
                    label=""
                    required
                  />
                </div>
                <div className="mt-4">
                  <FormikInput
                    name="mobileNumber"
                    placeholder="شماره تلفن همراه"
                    label=""
                    required
                  />
                </div>
                <div className="mt-4">
                  <FormikInput
                    name="phoneNumber"
                    placeholder="شماره تلفن ثابت"
                    label=""
                    required
                  />
                </div>
                <div className="mt-3">
                  <UploadDocument
                    file={values.nationalIdentity}
                    setFile={file => setFieldValue('nationalIdentity', file)}
                    title="بارگذاری کارت ملی"
                    description="عکس کارت ملی خود را بارگذاری کنید."
                  />
                  {touched.nationalIdentity && errors.nationalIdentity && (
                    <>
                      <div className="pt-3">
                        <small className="color-red-1">
                          <i className="icon-warning ps-2"></i>
                          {errors.nationalIdentity}
                        </small>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="mt-4">
                <CustomButton type="submit" title="ادامه" />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default ShopOwnerForm;
